<div class="flex w-full min-w-0 flex-col">
  <div
    (click)="selectTask()"
    [style.padding-left.px]="8 + depth() * 16"
    class="flex h-18 border-b border-proffeo-border min-w-0 items-center gap-2 p-2 hover:bg-proffeo-surface-muted cursor-pointer"
  >
    <button
      (click)="toggleExpand($event)"
      [attr.aria-expanded]="isExpanded()"
      [class.invisible]="!showChevron()"
      [class.proffeo-ui-tree-count-chip-active]="isExpanded()"
      type="button"
      class="proffeo-ui-tree-count-chip"
    >
      <mat-icon
        fontIcon="subdirectory_arrow_right"
        class="icon-sm opacity-50"
      />
    </button>
    <mat-radio-button
      [checked]="isSelected()"
      [disabled]="isForbidden()"
      [value]="task().id"
      [title]="task().name"
      class="max-w-full"
    >
      {{ getTaskIdentifier() }}
    </mat-radio-button>
  </div>

  @if (isExpanded()) {
    @for (child of children(); track child.id) {
      <proffeo-select-parent-task-tree-node
        [(expandedIds)]="expandedIds"
        [task]="child"
        [depth]="depth() + 1"
        [forbiddenIds]="forbiddenIds()"
        [selectedParentId]="selectedParentId()"
      />
    }
  }
</div>
